import { useEffect, useState } from 'react';
import api from './api';
import { normalizeSiteNames } from './metsEnterprise/adapters/siteOptions';

function unwrapList(payload) {
  if (Array.isArray(payload)) return payload;
  if (payload && Array.isArray(payload.results)) return payload.results;
  return [];
}

/**
 * Site names from GET /api/sites/ (empty until loaded).
 */
export function useSiteNames() {
  const [siteNames, setSiteNames] = useState([]);

  useEffect(() => {
    api.get('/sites/')
      .then((res) => setSiteNames(normalizeSiteNames(res.data)))
      .catch(() => setSiteNames([]));
  }, []);

  return siteNames;
}

/**
 * TMS names from GET /api/tms/ (empty until loaded).
 */
export function useTmsNames() {
  const [tmsNames, setTmsNames] = useState([]);

  useEffect(() => {
    api.get('/tms/')
      .then((res) => {
        const names = unwrapList(res.data)
          .map((row) => (typeof row === 'string' ? row.trim() : String(row?.name || '').trim()))
          .filter(Boolean);
        setTmsNames(Array.from(new Set(names)));
      })
      .catch(() => setTmsNames([]));
  }, []);

  return tmsNames;
}

export default useSiteNames;
